import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Sahifa almashganda tepaga skroll qiladi. */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}
